import { defineMessages } from "react-intl";
export default defineMessages({
    newReportLayoutBackToHome: {
        id: "aiDiscoverability.newReportLayout.backToHome",
        defaultMessage: "Back to Home",
    },
    newReportLayoutNext: {
        id: "aiDiscoverability.newReportLayout.next",
        defaultMessage: "Next",
    },
});
